import { createFileRoute, redirect } from '@tanstack/react-router';

import { addTrackCrumb } from '../error/tracking';

export const Route = createFileRoute('/*')({
  beforeLoad: function () {
    addTrackCrumb({
      category: 'route',
      message: window.location.pathname,
      level: 'warning',
    });

    const searchParams = new URLSearchParams(window.location.search);
    const status = searchParams.get('__clerk_status');

    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/app',
      search: status != null ? { status } : undefined,
      // completely reload and replace because there is no situation where
      // we want this route to be used
      replace: true,
      reloadDocument: true,
    });
  },
  component: () => null,
});
